import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

type Link = { path: string; label: string; tool: string };

@Component({
  selector: 'editor-toolbar-top',
  imports: [CommonModule],
  standalone: true,
  template: `
    <section>
      <div>
        @for(link of links; track link.path) {
        <button
          [class.active]="isActive(link.tool)"
          [disabled]="isActive(link.tool)"
          (click)="redirectToTool(link.path)"
        >
          {{ link.label }}
        </button>
        }
      </div>
    </section>
  `,
  styles: [
    `
      section {
        height: 1.1rem;
      }

      div {
        display: flex;
        transform: translateY(calc(-100% + 8px));
        border-bottom: 1px solid rgba(235, 236, 239, 1);
        max-width: 835px;
        width: 100%;
        position: fixed;
        background: #fff;
        z-index: 1;
        transition: all 0.3s ease-in-out;
        padding-block-start: 0.5rem;
      }

      section:hover div,
      div:hover {
        transform: translateY(0);
      }

      section:hover div:hover button {
        background: transparent !important;
      }

      button {
        font-size: 0.9rem;
        flex-grow: 1;
        padding-block: 0.75rem;
        background: rgba(235, 236, 239, 1);
        border: none;
        border-bottom: 2px solid transparent;
        transition: all 0.05s ease-in;
        color: #2d2d2d;
        font-weight: 500;
        margin-block-end: -1px;
        transition: all 0.3s ease;
      }

      button:hover:not(.active) {
        border-bottom: 2px solid #d2d5df;
      }

      button.active {
        border-bottom: 2px solid #08ba9c;
        background-color: #08ba9c;
      }

      @media (max-width: 1024px) {
        div {
          position: unset;
          transform: unset;
        }

        section {
          height: auto;
        }

        button {
          background-color: white;
        }

        button.active {
          background-color: white;
        }
      }
    `,
  ],
})
export class ToolbarComponent implements OnInit {
  currentPath: string = '';
  profile_id: number;
  doc_id: string;
  links: Array<Link> = [
    {
      path: '/grammar-check',
      label: 'Grammar Checker',
      tool: '/grammar-check',
    },
    {
      path: '/plagiarismchecker',
      label: 'Plagiarism Checker',
      tool: '/plagiarismchecker',
    },
    {
      path: '/paraphrasing',
      label: 'Paraphrasing Tool',
      tool: '/paraphrasing',
    },
    { path: '/article', label: 'Article Rewriter', tool: '/article' },
    {
      path: '/textsummarizer',
      label: 'Text Summarizer',
      tool: '/textsummarizer',
    },
  ];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentPath = new URL(
          event.urlAfterRedirects,
          window.location.origin
        ).pathname;
      });
  }

  ngOnInit(): void {
    this.profile_id = parseInt(localStorage.getItem('profile_id')) || 1;

    this.route.queryParams.subscribe((params) => {
      this.doc_id = params['doc'];
    });
  }

  isActive(path: string): boolean {
    return this.currentPath.startsWith(path);
  }

  redirectToTool(path: string) {
    const clone = document.getElementById('mm').cloneNode(true) as HTMLElement;
    clone.querySelectorAll('span').forEach((el) => {
      const parent = el.parentElement;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });
    const text = clone.innerHTML;
    localStorage.setItem('editorValueAI', text);
    this.router.navigate([path], { queryParams: { doc: this.doc_id } });
  }
}
